module.exports = __webpack_public_path__ + "assets/img/b8d41630455e500720aa976b3191b69d.png";